import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GetLanguageChoices } from '../data/LanguageChoices';

import { PreferencesService } from '../services/preferences.service';

@Component({
  selector: 'app-mobile-navigation',
  templateUrl: './mobile-navigation.component.html'
})
export class MobileNavigationComponent implements OnInit {
  choosingLanguage: boolean = false;
  languages: any;
  constructor(private preferenceService: PreferencesService, private router: Router) { }

  ngOnInit(): void {
    this.languages = GetLanguageChoices();
  }
  changeLanguage(index: number) {
    console.log('index is ', index);
    let code = this.languages[index].languageCode;
    this.preferenceService.languageCode = code;
    this.preferenceService.needsReload=true;
    this.router.navigateByUrl('');

  }
  startChangeLanguage() {
    this.choosingLanguage = true;
  }
  forceRefresh(){
    window.location.reload();
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
      for(let registration of registrations) {
       registration.unregister()
     } })
  }
}
